import {Component} from '@angular/core';
import {AbstractIcon} from '../abstract-icon';

@Component({
    selector: 'vui-tablet-icon',
    templateUrl: './tablet-icon.component.html'
})
export class TabletIconComponent extends AbstractIcon {

    constructor() {
        super();
        this.height = 24;
        this.width = 19;
    }
}
